import { render, staticRenderFns } from "./model-commonProblem.vue?vue&type=template&id=65000f6e&scoped=true&"
import script from "./model-commonProblem.vue?vue&type=script&lang=js&"
export * from "./model-commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./model-commonProblem.vue?vue&type=style&index=0&id=65000f6e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65000f6e",
  null
  
)

export default component.exports